export enum ShareRecommendationMethod {
  PRINT = 'print',
  EMAIL = 'email',
  VETSOURCE = 'vetsource',
  QRCODE = 'qrcode',
}
